
import { bus } from '@/main.js';

export default {
  data() {
    return {
      reconnectTimer: null,
      connectionAttempts: 0,
      maxAttempts: 5
    }
  },
  sockets: {
    connect() {
      /* eslint-disable no-console */
      console.log('VDSOCKET CONNECTED');
      this.joinRoom();
      bus.$emit('VDSOCKET_CONNECTED');
      if (this.reconnectTimer) {
        clearInterval(this.reconnectTimer);
        this.reconnectTimer = null;
      }
    },
    connecting() {
      /* eslint-disable no-console */
      console.log('VDSOCKET CONNECTING...');
    },
    disconnect(reason) {
      console.log('Disconnected, reason:', reason);
      console.log('Disconnected namespace:', this.$socket.nsp);
    },
    connect_failed() {
      console.log(' VDSOCKET CONNECT FAILED!');
    },
    connect_error(error) {
      console.error('Socket connection error:', error);
      console.log('Trying to connect to:', this.$socket.io.uri);  // 打印完整的连接URI

      // Reconnection logic
      const reconnectDelay = 5000
      console.log(`Will attempt to reconnect in ${reconnectDelay/1000} seconds...`)

      setTimeout(() => {
        if (!this.$socket.connected) {
          console.log('Starting reconnection...')
          this.$socket.connect()
        }
      }, reconnectDelay)

      // Debug info
      console.log({
        namespace: this.$socket.io.uri,
        socketId: this.$socket?.id,
        auth: {
          clinic: localStorage.getItem('orgCode'),
          user: localStorage.getItem('user'),
          token: localStorage.getItem('xsrf')
        },
        currentRoute: this.$route.path
      })
      this.handleConnectionFailure();
    },
    error(error) {
      console.error('Socket error:', error);
      console.log('Trying to connect to:', this.$socket.io.uri);  // 打印完整的连接URI
    },

    reconnect(attemptNumber) {
      console.log('Attempting to reconnect, attempt:', attemptNumber);
    },
    reconnect_failed() {
      console.error('Reconnection failed, please check your network connection');
    },

    // following is moved to user vuex store
    // USER_JOINED(d) {
    //   /* eslint-disable no-console */
    //   console.log('VDSOCKET JOINED', d);
    //   this.flash(`${d.username} joined this page`, 'success', { timeout: 5000 })
    // },
  },
  methods: {
    handleConnectionFailure() {
      this.connectionAttempts++;
      if (this.connectionAttempts >= this.maxAttempts) {
        console.error('Max reconnection attempts reached');
        if (this.$socket) {
          this.$socket.close();
        }
      }
    },
    joinRoom() {
      if (!this.$route.meta?.socketRoom) return

      const room = this.$route.meta.socketRoomNameIsDynamic
        ? this.$route[this.$route.meta.socketRoomNamePath]
        : this.$route.meta.socketRoomNamePath

      if (room) {
        console.log('Joining room:', room)
        this.$socket.emit('JOIN_ROOM', {
          room,
          username: this.user.name,
          socketId: this.$socket.id
        })
      }
    }
  },
  beforeDestroy() {
    if (this.reconnectTimer) {
      clearInterval(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    if (this.$socket) {
      this.$socket.close();
    }
  },
  mounted() {
    // monitor network status
    window.addEventListener('online', () => {
      console.log('Network connected');
      if (this.$socket) {
        this.$socket.connect();
      }
    });

    window.addEventListener('offline', () => {
      console.log('Network disconnected');
    });
  }
};
